export default {
    drawer: null,
    color: 'nav',    
    image: '',
    defaultImage: 'https://res.cloudinary.com/scorpion-betapp/image/upload/v1567788714/others/default-image.png',
    //logo: '../../../assets/logo.png',
     logo: 'https://static.wixstatic.com/media/91a58f_73807987a77f4ccabfdcd6ddb6038eca~mv2_d_7500_7500_s_4_2.png/v1/fill/w_120,h_120,al_c,q_80,usm_0.66_1.00_0.01/Original.webp'
}
  